<i18n src='@/locale/classification-map-localization.json'></i18n>

<template>
    <v-dialog
        v-model="vis"
        :max-width="maxWidth"
        :persistent="persistent"
        @keydown.escape="closeOnEsc && $emit('cancel')"
    >
        <template v-slot:activator="{ on, attrs }">
            <slot name="activator" :attrs="attrs" :on="on" />
        </template>
        <v-card>
            <v-card-title v-if="!hideTitle">{{ formTitle }}</v-card-title>
            <v-card-text>
                <v-container>
                    <slot></slot>
                </v-container>
            </v-card-text>
            <v-card-actions v-if="!hideActions">
                <v-spacer></v-spacer>
                <v-btn
                    @click="Save"
                    :disabled="disableSave"
                    class="primary white--text"
                    depressed
                >
                    <v-icon left>save</v-icon>
                    {{ $t('Save') }}
                </v-btn>
                <v-btn
                    @click="Cancel"
                    :disabled="disableCancel"
                    color="blue darken-1"
                    text
                >
                    {{ $t('Cancel') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        formTitle: {
            type: String,
            required: false,
        },
        persistent: {
            type: Boolean,
            default: true,
        },
        disableSave: {
            type: Boolean,
            default: false,
        },
        disableCancel: {
            type: Boolean,
            default: false,
        },
        maxWidth: {
            type: String,
            default: '500px',
        },
        closeOnEsc: {
            type: Boolean,
            default: true,
        },
        hideTitle: {
            type: Boolean,
            default: false
        },
        hideActions: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        value(val) {
            this.vis = val;
        },
        vis(val) {
            if (!val) {
                this.Cancel();
            } else {
                this.$emit('input', true);
            }
        },
    },
    data() {
        return {
            vis: false,
        };
    },
    methods: {
        Save() {
            this.$emit('save');
        },
        Cancel() {
            this.$emit('input', false);
        },
    },
};
</script>

<style>
</style>